import * as _ from 'lodash';
var TEMPLATE_REGEX = /\{\{([^\}]+)\}\}/g;
export function interpolate(val) {
    /* Check for all non-constants values {{something}} */
    var hasEmbeddedExpressions = val.match(/\{\{[^\'].*[^\']\}\}/g);
    /* Check for all constants values {{'Mama doing pizza'}} */
    var hasConstantValue = val.match(/\{\{\'(.*)\'\}\}/g);
    if (hasEmbeddedExpressions === null && hasConstantValue === null) {
        return; /* Need to save original $interpolate's behavior */
    }
    return function (ctx) {
        var formattedString = val;
        if (hasConstantValue) {
            /* Replace constant placeholder to string {{\'Will do my Lord\'}} => Will do my Lord */
            formattedString = formattedString.replace(/\{\{\'(.*)\'\}\}/g, '$1');
        }
        if (hasConstantValue && hasEmbeddedExpressions === null) {
            return formattedString;
        }
        if (ctx === undefined) {
            return;
        }
        if (Object.keys(ctx).length === 0) {
            return;
        }
        /* Checking for a placeholders like {{person.name}} */
        var matchedValues = val.match(TEMPLATE_REGEX);
        var embeddedExpressions = matchedValues
            ? matchedValues.map(function (item) { return item.slice(2).slice(0, -2); })
            : [];
        var hasAllMatches = embeddedExpressions.every(function (value) {
            return _.get(ctx, value);
        });
        if (!hasAllMatches) {
            return;
        }
        /* Replace placeholders */
        formattedString = val.replace(TEMPLATE_REGEX, function (pattern, match) {
            return _.get(ctx, match);
        });
        return formattedString;
    };
}
//# sourceMappingURL=interpolate.js.map